import type { SnippetReferenceResolved } from './types';
import { EditInStrapiBadge } from '@/components/preview/EditInStrapiBadge';
import { SlotRenderer } from '@/components/SlotRenderer';

export function SnippetReferenceComponent({
  resolved,
}: {
  resolved: SnippetReferenceResolved;
}) {
  const { snippet } = resolved;
  // Per concept §3.4: a widget that finds no data hides itself.
  if (!snippet) {
    return null;
  }
  return (
    <div className="group/snippet relative">
      {/*
        A pass-through: the snippet's blocks stand in for this widget, so the
        zone owes them the page container exactly as a page's own zone does.
        The snippet `blocks` zone admits `hero`, `gradient-section` and
        `card-section`, and those have to stay able to escape it — which is why
        this is `container="page"` and not a wrapping div (70.14-Widget-Width).
      */}
      <SlotRenderer
        blocks={snippet.blocks}
        zoneName="snippet-body"
        container="page"
      />
      {snippet.documentId && (
        <div className="pointer-events-none absolute top-2 right-2 opacity-0 transition-opacity group-hover/snippet:opacity-100">
          <div className="pointer-events-auto">
            <EditInStrapiBadge
              target={{
                collection: 'api::content-snippet.content-snippet',
                documentId: snippet.documentId,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export function SnippetReferenceSkeleton() {
  return (
    // The skeleton stands in for content, so it takes the container the
    // widget itself declines.
    <div
      aria-busy
      className="mx-auto h-24 max-w-6xl animate-pulse rounded bg-gray-100 px-4 pt-4 lg:px-9"
    />
  );
}
